import { UserSyncMutation } from './user-provisioning/user-sync-mutation.js'
import { ProjectManagement } from './project/project-management.js'
import { TaskManagement } from './task/task-management.js'
import { WebhookManagement } from './webhook/webhook-management.js'
import { MLBackendService } from './ml/ml-backend-service.js'
import { PredictionManagement } from './prediction/prediction-management.js'
import { LabelStudioAIPredictionService } from './ai-prediction-service.js'
import { DatasetLabelingIntegration } from './dataset-labeling-integration.js'
import { ExternalDataSourceService } from './external-data-source-service.js'

export const schema = {
  resolverClasses: [
    /* RESOLVER CLASSES */
    UserSyncMutation,
    ProjectManagement,
    TaskManagement,
    WebhookManagement,
    MLBackendService,
    PredictionManagement,
    LabelStudioAIPredictionService,
    DatasetLabelingIntegration,
    ExternalDataSourceService
  ]
}
